export default __webpack_public_path__ + "static/media/results_spelling.9cbaac29.png";